import gql from 'graphql-tag';

export const STATISTICS = gql`
  query statistics(
    $startPeriod: Date!
    $endPeriod: Date!
    $businessOwnerId: Int
  ) {
    accommodationsBookingsStatistic(
      startPeriod: $startPeriod
      endPeriod: $endPeriod
      businessOwnerId: $businessOwnerId
    ) {
      accommodationBookings {
        accommodationTitle
        numberOfBookedSlots
        status
      }
      capacityBooked
      capacityAvailable
      bookingsPerPlatform {
        platform
        bookingsPerPlatform
      }
      numberOfAllSlots
      numberOfBookedSlots
    }
    activitiesBookingsStatistic(
      startPeriod: $startPeriod
      endPeriod: $endPeriod
      businessOwnerId: $businessOwnerId
    ) {
      open {
        capacityBooked
        capacityAvailable
        maxParticipants
        bookedParticipants
        bookingPerActivity {
          activityTitle
          status
          bookedParticipants
        }
        bookingsPerPlatform {
          platform
          bookingsPerPlatform
        }
      }
      private {
        capacityBooked
        capacityAvailable
        bookedSlots
        maxSlots
        bookingPerActivity {
          activityTitle
          status
          numberOfBookedSlots
        }
        bookingsPerPlatform {
          platform
          bookingsPerPlatform
        }
      }
    }
  }
`;
